import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(public)/onlinebookingresponse')({
  component: OnlineBookingResponsePage,
});

function OnlineBookingResponsePage() {
  return <div>TODO: Booking Confirmation</div>;
}
